module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tagName, {
    tag: "component",
    staticClass: "ushk-star"
  }, [_c('i', {
    staticClass: "ushk-star_active",
    class: {
      'ushk-star_important': _vm.width > 2
    },
    style: ({
      width: ((_vm.width * 20) + "%")
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12d9ab93","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Star.vue
// module id = ZfbR
// module chunks = 2